import { Component,OnInit,OnDestroy,AfterViewInit,Input } from '@angular/core';
import { NgbModal,NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { takeWhile } from "rxjs/operators";

import {
    FvmsCommonService
    ,FvmsApiAuthService
    ,FvmsApiDtgGeoFenceService
} from "src/app/shared/service";
import {
    PagingInfo
    ,DtgActionType
} from "src/app/shared/vo";
import {
    DtgManageCarSearchComponent
} from "src/app/dtg/manage/car";

@Component({
    selector: "[dtg-geofence-car-list]"
    ,templateUrl: './dtg.geofence.car.list.component.html'
    ,providers: []
})
export class DtgGeofenceCarListComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    companyInfo:any;
    currentUserInfo:any;
    dtgTeamId:string = "";
    selectedGeoFenceConf:any;
    pagingInfoConf:PagingInfo = new PagingInfo();
    pagingInfoCar:PagingInfo = new PagingInfo();
    searchValueConf:string;
    searchValueCar:string;
    useYnConf:string;
    useYnCar:string;
    listGeofenceConf:any[];
    listGeofenceCar:any[];
    DtgActionType = DtgActionType;

    constructor(
        private fvmsCommonService:FvmsCommonService
        ,private fvmsApiAuthService:FvmsApiAuthService
        ,private fvmsApiDtgGeoFenceService:FvmsApiDtgGeoFenceService
        ,private modalService: NgbModal
    ) {
        this.companyInfo = this.fvmsCommonService.getCompanyInfo();
        this.currentUserInfo = this.fvmsApiAuthService.getLoginUserInfo();
        this.fvmsCommonService.subscribeCompanyInfo()
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(companyInfo => {
                this.companyInfo = companyInfo;
            });
     }

    ngOnInit() {

    }

    ngOnDestroy() {
        this.isContinue = false;
    }

    ngAfterViewInit() {

    }

    clickSearchGeofenceConf(){
        this.reloadListGeoFenceConf();
    }

    // 설정 목록
    reloadListGeoFenceConf(){
        let searchInfo = {
            companyId : this.companyInfo?.companyId || 0
            ,dtgTeamId : this.dtgTeamId
            ,searchValue : this.searchValueConf
            ,useYn : this.useYnConf
        };
        this.fvmsApiDtgGeoFenceService.listGeoFenceConf(searchInfo,this.pagingInfoConf)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    this.listGeofenceConf = apiResponse.resultValue;
                    this.pagingInfoConf = apiResponse.pagingInfo;
                }
            },err => {
                console.error("reloadListGeoFenceConf",err);
            }
            ,() => {});
    }

    callbackClickPageNumberConf(pageNo: number) {
        this.pagingInfoConf.curPage=pageNo;
        this.reloadListGeoFenceConf();
    }

    callbackChangeCountRowPerPageConf(pageSize:number){
        this.pagingInfoConf.pageSize = pageSize;
        this.callbackClickPageNumberConf(1);
    }

    clickFindAllCar(itemConf){
        this.selectedGeoFenceConf = itemConf;
        this.reloadListGeoFenceCar();
    }

    // 설정에 해당하는 차량 목록
    reloadListGeoFenceCar(){
        let searchInfo = {
            companyId : this.companyInfo?.companyId || 0
            ,dtgTeamId : this.dtgTeamId
            // ,searchValue : this.searchValue
            ,geoFenceId : this.selectedGeoFenceConf.geoFenceId
            ,useYn : this.useYnCar
        };
        this.fvmsApiDtgGeoFenceService.listGeoFenceConfCar(searchInfo,this.pagingInfoCar)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    this.listGeofenceCar = apiResponse.resultValue;
                    this.pagingInfoCar = apiResponse.pagingInfo;
                }
            });
    }

    callbackClickPageNumberCar(pageNo: number) {
        this.pagingInfoConf.curPage=pageNo;
        this.reloadListGeoFenceCar();
    }

    callbackChangeCountRowPerPageCar(pageSize:number){
        this.pagingInfoConf.pageSize = pageSize;
        this.callbackClickPageNumberCar(1);
    }

    clickDeleteCar(itemCar){
        this.deleteGeoFenceCar(itemCar);
    }

    deleteGeoFenceCar(itemCar){
        let searchInfo = {
            geoFenceId : this.selectedGeoFenceConf.geoFenceId
            ,dtgUnitId : itemCar.dtgUnitId
        };
        this.fvmsApiDtgGeoFenceService.deleteGeoFenceConfCar(searchInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    this.callbackChangeCountRowPerPageCar(1);
                }
            });
    }

    clickOpenModalCarList(dtgActionType:DtgActionType){
        if(!this.selectedGeoFenceConf){
            return;
        }
        let modalRef = this.modalService.open(
            DtgManageCarSearchComponent
            ,{
                centered:true
                ,size: "xl"
                ,backdrop:"static"
                //windowClass: "dark-modal"
                ,scrollable: true
            }
        );

        modalRef.result.then((resultModal) => {
            if(resultModal.result === "ok"){
                // console.log("resultModal.carInfo",resultModal.carInfo);
                if(this.listGeofenceCar){
                    let sizeList = this.listGeofenceCar.length;
                    for(let a=0;a<sizeList;a++){
                        let item = this.listGeofenceCar[a];
                        if(item.dtgUnitId === resultModal.carInfo.dtgUnitId){
                            return;
                        }
                    }
                }
                this.updateGeoFenceCar(resultModal.carInfo);

                // this.dtgUnitId = resultModal.carInfo.dtgUnitId;
                // this.dtgCarNo = resultModal.carInfo.dtgCarNo;
                // this.reloadListItem();
            }
        });
    }

    updateGeoFenceCar(itemCar){
        let searchInfo = {
            geoFenceId : this.selectedGeoFenceConf.geoFenceId
            ,dtgUnitId : itemCar.dtgUnitId
            ,runDay : 2
            ,runCnt : 1
            ,runOrder : 1
        };
        this.fvmsApiDtgGeoFenceService.updateGeoFenceConfCar(searchInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    this.callbackChangeCountRowPerPageCar(1);
                }
            });
    }
}